import { createAsyncThunk } from "@reduxjs/toolkit";
import { tournamentConfigAPIs } from "services/api/core/tournamentConfigAPIs";

export const getOrCreateTournamentConfig = createAsyncThunk(
  "core/tournamentConfig/getOrCreateTournamentConfig",
  async (payload) => {
    try {
      const response = await tournamentConfigAPIs.getOrCreateTournamentConfig(payload);

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const updateTournamentConfig = createAsyncThunk(
  "core/tournamentConfig/updateTournamentConfig",
  async ({ payload, tournamentId }, { rejectWithValue }) => {
    try {
      const response = await tournamentConfigAPIs.updateTournamentConfig({ payload, tournamentId });

      return response.data;
    } catch (error) {
      console.log(error);

      return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
    }
  },
);

export const testTournamentConfigLLMOCR = createAsyncThunk(
  "core/tournamentConfig/testTournamentConfigLLMOCR",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await tournamentConfigAPIs.testTournamentConfigLLMOCR(payload);

      return response.data;
    } catch (error) {
      console.log(error);

      return rejectWithValue(error?.response?.data ?? { message: "Something went wrong. Please try again." });
    }
  },
);

export const testTournamentConfigReplayDetection = createAsyncThunk(
  "core/tournamentConfig/testTournamentConfigReplayDetection",
  async (payload) => {
    try {
      const response = await tournamentConfigAPIs.testTournamentConfigReplayDetection(payload);

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);

export const triggerStreamReplayDetection = createAsyncThunk(
  "core/tournamentConfig/triggerStreamReplayDetection",
  async (payload) => {
    try {
      const response = await tournamentConfigAPIs.triggerStreamReplayDetection(payload);

      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
);
